/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useCallback, useState } from 'react';
import { Form } from '@unform/web';
import * as yup from 'yup';
import { FormHandles } from '@unform/core';
import Input from '../../../../components/Input';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import TableLoader from '../../../../components/TableLoader';
import getValidationErrors from '../../../../utils/getValidationErrors';
import { Container } from './styles';

interface AddDepartmentModalProps {
  show: boolean;
  title: string;
  handleClose(): void;
  handleAdd(name: string): Promise<void>;
}

const schema = yup.object().shape({
  nomeDepartamento: yup
    .string()
    .required('O nome do departamento é obrigatório'),
});

const AddDepartmentModal: React.FC<AddDepartmentModalProps> = ({
  handleClose,
  handleAdd,
  show,
  title,
}) => {
  const formTableRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const handleSubmit = useCallback(async (data: any) => {
    try {
      formTableRef.current?.setErrors({});

      await schema.validate(data, {
        abortEarly: false,
      });
      setLoading(true);
      await handleAdd(data.nomeDepartamento);
      setLoading(false);
    } catch (err: any) {
      if (err instanceof yup.ValidationError) {
        const errors = getValidationErrors(err);
        formTableRef.current?.setErrors(errors);
      }
    }
  }, []);

  return (
    <Container>
      <Modal show={show} title={title} handleClose={handleClose}>
        {loading ? (
          <TableLoader />
        ) : (
          <Form ref={formTableRef} onSubmit={handleSubmit}>
            <Input
              name="nomeDepartamento"
              id="nomeDepartamento"
              label="Nome"
              schema={schema}
              placeholder="Digite o nome do departamento"
            />
            <div className="buttonsContainer">
              <Button color="orange" padding="1" type="submit">
                Adicionar
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    </Container>
  );
};

export default AddDepartmentModal;
